/**
 * MathtasticIcon - Icon for P-type (mathtastic) limiter groups and math expressions
 * Uses the Calculate icon with a distinctive lavender color
 */

import { forwardRef } from 'react';
import { Calculate } from '@mui/icons-material';
import { SvgIconProps } from '@mui/material';

// Lavender color for mathtastic elements - unique in the app
export const MATHTASTIC_COLOR = '#9370DB';

interface MathtasticIconProps extends Omit<SvgIconProps, 'color'> {
  fontSize?: 'small' | 'medium' | 'large' | 'inherit';
}

const MathtasticIcon = forwardRef<SVGSVGElement, MathtasticIconProps>(
  ({ fontSize = 'medium', sx, ...rest }, ref) => {
    return (
      <Calculate
        ref={ref}
        fontSize={fontSize}
        sx={{
          color: MATHTASTIC_COLOR,
          ...sx,
        }}
        {...rest}
      />
    );
  }
);

MathtasticIcon.displayName = 'MathtasticIcon';

export default MathtasticIcon;
